import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router';
import { TJobOverviewPageRoutes } from './Types';
import { useSafeLocationState } from './useSafeLocationState';
import { firePermJobOverviewTabClicked } from '~/posthogs/events';
import { JobOverviewTab } from '~/posthogs/events/PermJobs/types';

export enum TAB {
  JOB_DETAILS = 'job-details',
  CANDIDATES = 'candidates',
  WORKING_INTERVIEWS = 'onsite-interviews',
}

const tabOrders = [TAB.JOB_DETAILS, TAB.CANDIDATES, TAB.WORKING_INTERVIEWS];

// Map from TAB enum to JobOverviewTab enum for analytics
const tabToAnalyticsMap: Record<TAB, JobOverviewTab> = {
  [TAB.JOB_DETAILS]: JobOverviewTab.JobDetails,
  [TAB.CANDIDATES]: JobOverviewTab.Candidates,
  [TAB.WORKING_INTERVIEWS]: JobOverviewTab.OnsiteInterviews,
};

export const useJobOverview = () => {
  const { postingId, type } = useParams<TJobOverviewPageRoutes>();
  const navigate = useNavigate();
  const state = useSafeLocationState();

  const activeTab: TAB = tabOrders.includes(type as TAB) ? (type as TAB) : TAB.JOB_DETAILS;

  const onChangeTab = useCallback(
    (tab: string) => {
      const selectedTab = tab as TAB;

      // Only proceed if we're actually changing tabs
      if (selectedTab === activeTab) {
        return;
      }

      // Track tab click event
      if (postingId) {
        firePermJobOverviewTabClicked({
          postingId,
          tabName: tabToAnalyticsMap[selectedTab],
        });
      }

      navigate(`/permanent-jobs/job-overview/${postingId}/${selectedTab}`, {
        replace: true,
        state,
      });
    },
    [activeTab, navigate, postingId, state],
  );

  return {
    activeTab,
    onChangeTab,
  };
};
